// Bespoke voxel prefabs for building kinds that previously fell back to
// placeholder mappings (e.g. library → tower, granary → house). Each is
// authored to be visually distinct in the instanced voxel renderer.
//
// Coordinate convention: origin at the building's base on the tile. Y up,
// X right, Z forward (toward camera). Buildings typically span a 4-6
// voxel footprint and stand 3-8 voxels tall.
//
// Voxel scale: 1/16 world unit per voxel. A standard 5×5 tile building is
// 80×80 world units — these prefabs render around 1 hex tile wide.
//
// Split by group (the registry below is the single assembly point):
//   buildings_extra_civil.ts     production / civilian / food
//   buildings_extra_military.ts  guilds, workshops, barracks, mine
//   buildings_extra_civic.ts     tiered walls + towers, theatre, colosseum
//   buildings_extra_shared.ts    `box()` helper + stone / wood palette

import { colosseum, theater, wallPrefab, watchTowerPrefab } from './buildings_extra_civic.js';
import {
  bank,
  brewery,
  forgeHut,
  granary,
  herbalistHut,
  library,
  pasture,
  well,
  winery,
} from './buildings_extra_civil.js';
import {
  assassinGuild,
  barracks,
  mine,
  siegeWorkshop,
  slaveMarket,
} from './buildings_extra_military.js';
import type { StructurePrefab } from './types.js';

export const BUILDING_PREFABS_EXTRA: Readonly<Record<string, StructurePrefab>> = {
  forge_hut: forgeHut,
  granary,
  well,
  herbalist_hut: herbalistHut,
  library,
  bank,
  pasture,
  winery,
  brewery,
  assassin_guild: assassinGuild,
  siege_workshop: siegeWorkshop,
  slave_market: slaveMarket,
  walls_1: wallPrefab(1),
  walls_2: wallPrefab(2),
  walls_3: wallPrefab(3),
  tower_1: watchTowerPrefab(1),
  tower_2: watchTowerPrefab(2),
  tower_3: watchTowerPrefab(3),
  theater,
  colosseum,
  barracks,
  mine,
};
